export default __webpack_public_path__ + "static/media/template1.4f40ab66.svg";